<template>
  <div class="purchase-box">
    <el-tabs v-model="editableTabsValue" @tab-click="handleClick">
      <el-tab-pane label="代采组" name="group"></el-tab-pane>
      <el-tab-pane label="代采员" name="member"></el-tab-pane>
    </el-tabs>

    <div v-if="editableTabsValue == 'group'">
      <get-list></get-list>
    </div>
    <div v-if="editableTabsValue == 'member'">
      <member></member>
    </div>
  </div>
</template>

<script>
import GetList from "./GetList";
import Member from "./Member";

export default {
  components: {
    Member,
    GetList,
  },
  data() {
    return {
      editableTabsValue: "group",
    };
  },
  mounted() {
    let tab = { name: "group" };
    let pgid = "";
    pgid = this.$route.query.pgid;
    const { type } = this.$route.query;
    if (pgid != "undefined" && pgid != null && pgid != "" && pgid) {
      tab = { name: "member" };
    }
    if (type != "undefined" && type != null && type != "" && type) {
      tab = { name: type };
    }
    this.handleClick(tab);
  },
  methods: {
    handleClick(tab) {
      this.editableTabsValue = tab.name;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/Purchase.vue